import { API } from 'common/constants/api-urls';
import useFetch from 'use-http';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import QueryString from 'query-string';
export const META_DATA_STATUSES = {
  LOADING: undefined,
  ERROR: 'error',
  SUCCESS: 'success'
};

const useProviderMetaData = ({
  entity_name,
  rawData = [],
  sensor_authorization_id,
  cachePolicy = 'no-cache',
  chunkSize = Infinity
}) => {
  const [urls, setUrls] = useState([]);
  const [data, setData] = useState([]);
  const { get: getExtraData } = useFetch(
    `${API.PROVIDER_ENTITIES_PATH}/${entity_name}/metadata`,
    { cachePolicy }
  );
  const providerIds = _.orderBy(rawData, 'name')
    .map(entity => entity.provider_id)
    .filter(Boolean);
  const getProviderIdsFromUrl = url =>
    QueryString.parse(url)?.entity_ids?.split(',') || providerIds;

  const fetchUrls = async () => {
    const firstUrl = urls[0];
    const fetchedProviderIds = getProviderIdsFromUrl(firstUrl);
    try {
      const response = await getExtraData(firstUrl);
      const responseEntities = _.get(response, 'entities', []);
      const responseEntitiesKeys = _.keyBy(responseEntities, 'entity_id');

      const metaDataEntities = fetchedProviderIds.map(providerId => {
        const metaEntity = responseEntitiesKeys[providerId];
        return {
          provider_id: providerId,
          ...(metaEntity
            ? { ...metaEntity.data, metaStatus: META_DATA_STATUSES.SUCCESS }
            : { metaStatus: META_DATA_STATUSES.ERROR })
        };
      });
      setData(prev => [...prev, ...metaDataEntities]);
    } catch (e) {
      const failedEntities = fetchedProviderIds.map(providerId => ({
        provider_id: providerId,
        metaStatus: META_DATA_STATUSES.ERROR
      }));
      setData(failedEntities);
    } finally {
      const urlsWithoutFirst = urls.filter((_, idx) => idx !== 0);
      setUrls(urlsWithoutFirst);
    }
  };

  useEffect(() => {
    if (urls.length) fetchUrls();
  }, [urls.length]);

  return data;
};

export default useProviderMetaData;
